module.exports = __webpack_public_path__ + "static/nikki_pushup_cropped_660-0afbbc5846c55f91c09a505769a96b9e.jpg";